var map = {
	"./Alert.svg": "03bb",
	"./Dropdown.svg": "c0ce",
	"./Form.svg": "99b2",
	"./Modal.svg": "da94",
	"./Spin.svg": "a93a",
	"./Tabs.svg": "3c5f",
	"./Upload.svg": "db78",
	"./avatar.jpg": "915e",
	"./callout.svg": "52e6",
	"./column.jpg": "7950",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";